/** Chart and label helpers for ML Insights tabs. */

export function getSentimentColor(sentiment) {
  if (sentiment >= 0.7) return 'success';
  if (sentiment >= 0.4) return 'warning';
  return 'error';
}

export function getSentimentLabel(sentiment) {
  if (sentiment >= 0.7) return 'Positive';
  if (sentiment >= 0.4) return 'Neutral';
  return 'Negative';
}

export function getQualityColor(quality) {
  if (quality >= 0.8) return 'success';
  if (quality >= 0.5) return 'warning';
  return 'error';
}

export function getMarketShareChartData(competitiveOverview) {
  if (!competitiveOverview?.market_share_distribution) return [];
  return competitiveOverview.market_share_distribution
    .sort((a, b) => b.market_share - a.market_share)
    .slice(0, 10)
    .map((item) => ({
      name:
        item.competitor_name.length > 15
          ? item.competitor_name.substring(0, 15) + '...'
          : item.competitor_name,
      marketShare: parseFloat(item.market_share || 0),
      followers: item.followers || 0,
    }));
}

export function getQualityScoreChartData(contentAnalysis) {
  if (!contentAnalysis?.all_competitors) return [];
  return contentAnalysis.all_competitors
    .sort((a, b) => b.quality_score - a.quality_score)
    .slice(0, 10)
    .map((item) => ({
      name:
        item.name.length > 15
          ? item.name.substring(0, 15) + '...'
          : item.name,
      qualityScore: parseFloat(item.quality_score || 0) * 100,
      engagement: parseFloat(item.avg_engagement || 0),
    }));
}

export function getPlatformPresenceChartData(platformPresence) {
  const perf = platformPresence?.platform_performance;
  if (!perf || typeof perf !== 'object') return [];
  return Object.entries(perf).map(([platform, data]) => ({
    platform: platform.charAt(0).toUpperCase() + platform.slice(1),
    competitors: data.competitor_count || 0,
    engagementRate: parseFloat(data.engagement_rate_percentage || 0),
    followers: data.total_followers || 0,
  }));
}

export function getSentimentPieData(sentimentAnalysis) {
  if (!sentimentAnalysis) return [];
  return [
    {
      name: 'Positive',
      value: sentimentAnalysis.positive_count || 0,
      color: '#00C49F',
    },
    {
      name: 'Negative',
      value: sentimentAnalysis.negative_count || 0,
      color: '#FF8042',
    },
    {
      name: 'Neutral',
      value: sentimentAnalysis.neutral_count || 0,
      color: '#FFBB28',
    },
  ].filter((item) => item.value > 0);
}
